// app/javascript/projects/components/MemoInput.jsx

import React from 'react';
import { withToastManager } from 'ui/toast';
import { useCreateMemo } from 'hooks/memos/mutations';
import AvatarInput from './AvatarInput';

function MemoInput(props) {
  const createMemoMutation = useCreateMemo();

  async function addMemo(memo) {
    try {
      const result = await createMemoMutation.mutateAsync({
        excerptId: props.excerpt_id,
        text: memo,
        userId: props.userId
      });
      
      // Handle AI requests
      if (memo.startsWith('@ai_assistant')) {
        props.askAI(memo);
      }
      
      return result;
    } catch (error) {
      addMemoErrorHandler();
      throw error;
    }
  }

  function addMemoErrorHandler() {
    props.toastManager.add(
      'Error saving memo. Refresh and try again.', {
      appearance: 'error',
      autoDismiss: true,
      autoDismissTimeout: 7000
    });
  }
  
  return (
    <AvatarInput
      addInput={addMemo}
      handleError={addMemoErrorHandler}
      excerptId={props.excerpt_id}
      initials={props.initials}
      color={props.color}
      featureFlagAICoding={props.featureFlagAICoding}
    />
  );
}

export default withToastManager(MemoInput);